import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { ExportState } from './export.state';
import { getters } from './export.getters';
import { mutations } from './export.mutations';
import { actions } from './export.actions';

VueXHelper.setStoreModule(Module.EXPORT, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new ExportState(),
  getters,
  mutations,
  actions,
};
